// Typed helpers for narrowing caught errors (axios / NestJS) without `any` (T-407).
// Pair with notify.error(err, fallback) from '@/lib/toast' for the toast message;
// use these when a handler needs the HTTP status or the message string directly.

export interface ApiErrorShape {
  response?: {
    status?: number;
    data?: { message?: string | string[] };
  };
  message?: string;
}

/** True for any object that may carry an axios-style `response`/`message`. */
export function isApiError(err: unknown): err is ApiErrorShape {
  return typeof err === 'object' && err !== null;
}

/** HTTP status from an axios-style error, or undefined. */
export function getApiErrorStatus(err: unknown): number | undefined {
  return isApiError(err) ? err.response?.status : undefined;
}

/** Seconds to wait, from a 429 body `retryAfterSeconds` (POS-I184), or undefined. */
export function getApiRetryAfterSeconds(err: unknown): number | undefined {
  if (!isApiError(err)) return undefined;
  const value = (err.response?.data as { retryAfterSeconds?: unknown } | undefined)?.retryAfterSeconds;
  return typeof value === 'number' && Number.isFinite(value) && value > 0 ? value : undefined;
}
